import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { NavBar } from '../../components/layout/NavBar';
import './Login.module.css'
import { Services } from '@/services/services';
import { Machine } from '@/services/model/machine';
import { Translates } from '@/services/repository/i18n';
import { SubmitHandler, useForm } from 'react-hook-form';
import { LoginForm, FormData, FormErrors } from './Login.form';

export const LogoutPage = ({ services }: { services: Services }) => {
  const navigate = useNavigate()

  useEffect(() => {
    services.session.logout()
  }, [])
    
  return null
}
